import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LogBase from "./_LogBase.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const columns = [
  { prop: "access_date", label: "Огноо" },
  { prop: "method", label: "Method" },
  { prop: "uri", label: "URI" },
  { prop: "client_ip", label: "IP" },
  { prop: "username", label: "Хэрэглэгч" },
  { prop: "hash", label: "Hash" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LogBase, {
    title: "Хандсан лог",
    endpoint: "/logs/access",
    columns: columns,
    show: { ip: true, method: true }
  }))
}
}

})